import { useMutation } from '@tanstack/react-query'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { postCreatePayInV3, postCreatePayment } from 'services/PaymentsService'
import { PaymentsCreateRequest } from 'types/payments'

/**
 * @param beneficiaryCurrency the receiving wallet's own currency, used by the v3 pay-in beneficiary
 */
export const useCreatePaymentMutation = (beneficiaryCurrency?: string) => {
  const { enablePayInV3 } = useFeatureFlags()

  return useMutation({
    mutationFn: (payload: PaymentsCreateRequest) =>
      enablePayInV3 ? postCreatePayInV3(payload, beneficiaryCurrency) : postCreatePayment(payload),
  })
}
